export enum FeatureToggle {
  marketingToolingEnabled = 'rt_rfm_v2_enabled',
  marketingToolingV2DisabledOverride = 'rt_rfm_v2_disabled_overrides',
  marketingToolingRetailerEnabled = 'rt_rfm_v2_retailer_enabled',
  marketingToolingRetailerDisabledOverride = 'rt_rfm_v2_retailer_disabled_override',
  segmentLibraryEnabled = 'rt_segment_library_v2_enabled',
  budgetCappingManagementEnabled = 'rt_marketing_tooling_budget_capping_management_enabled',
  memberIdCsvToolingEnabled = 'rt_loyalty_id_csv_tooling_enabled',
  onSiteAndCrmCampaigns = 'rt_mt_on_site_and_crm_campaigns',
  onSiteAndDirectLinkCampaigns = 'rt_mt_on_site_and_direct_link_campaigns',
  enableLotusCRMCampaign = 'rt_mt_enable_lotus_crm_campaign',
  useCampaignBriefs = 'rt_mt_use_campaign_briefs',
  flyersCampaignConfiguration = 'rt_mt_flyers_campaign_configuration',
  elementTrackingEnabled = 'rt_mt_element_tracking_enabled',
  retailerDepartmentOfferEnabled = 'rt_retailer_department_offer_enabled',
  // Reuses the legacy RFM template toggle so EI rollout is a single audience across domains.
  embeddedInstacartEnabled = 'rt_campaigns_v2_template_embedded_instacart_enabled',
  itemLevelOfferStackabilityEnabled = 'rt_item_level_offer_stackability_enabled',
  showAllFeeRewardOptions = 'rt_mt_show_all_fee_reward_options',
  freeDeliveryOrPickupEnabled = 'rt_mt_free_delivery_or_pickup_enabled',
  // Default-deny gate for the fee reward option on retailer-specific Marketplace campaigns.
  feeRewardEnabled = 'rt_retailer_specific_mp_fee_reward_enabled',
  offlineDiscoverabilityEnabled = 'rt_mt_offline_discoverability_enabled',
  standaloneUnsubscribeListsEnabled = 'rt_mt_standalone_unsubscribe_lists_enabled',
  bulkCouponCodesCreationEnabled = 'rt_bulk_coupon_codes_creation_enabled',
  campaignDraftCopyPermissionGate = 'rt_marketing_tooling_campaign_draft_copy_permission_gate',
  // Gates the include/exclude ("has / has not been included") wording for the
  // api_audience_ids targeting rule. When off, the rule keeps its legacy
  // inclusion-only "API segment is ..." copy without the negation dropdown.
  excludeApiSegmentEnabled = 'rt_mt_exclude_api_segment',
  // When on, direct-link campaigns show the otherwise-hidden contextual targeting features.
  showDirectLinkContextualTargetingFeatures = 'rt_show_direct_link_contextual_targeting_features',
  // Lowers the SFP campaign minimum-spend floor from $2 to $1. Gated by account
  // or partner; consumed via the `allowOneDollarMinimumSpend` capability which
  // additionally requires siteContext.isStorefrontPro.
  oneDollarMinSpendEnabled = 'rt_mt_1_dollar_min_spend',
  // SFP "Recurring email/push send" schedule option; consumed via the
  // `allowSfpRecurringCrmSchedule` capability which additionally requires an
  // internal account and CRM campaigns access.
  sfpRecurringCrmCampaigns = 'rt_mt_sfp_recurring_crm_campaigns',
  // Dev-period gate for the Canvas channel on Storefront Pro. Paired with the
  // internal-account check (account.isInternal) via the `allowCanvasChannel`
  // capability (the allowBulkCouponCodes pattern).
  sfpCanvasChannel = 'rt_mt_sfp_canvas_channel',
}
